module.exports = __webpack_public_path__ + "3ca044849f9eb9998128d2b0eb31a61a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pink-diamond-right-s.png
// module id = 2582
// module chunks = 0